import React, { useCallback, useRef } from 'react'
import { ProTable } from '@ant-design/pro-components'
import { Form, Select, Tooltip } from 'antd'
import moment from 'moment'
import { useGetCommonEnum } from '@/utils/hook'
import { getAsyncTask, EnumType } from '@/api/common'


function AsyncTask() {
  const [form] = Form.useForm()
  const actionRef = useRef(null)
  const [asyncTaskType] = useGetCommonEnum(EnumType.asyncTaskType);
  const [asyncTaskStatus] = useGetCommonEnum(EnumType.asyncTaskStatus);

  const columns = [
    {
      title: '任务类型',
      dataIndex: 'taskType',
      ellipsis: true,
      colSize: 2,
      initialValue: '',
      renderFormItem: (item, { type, defaultRender, ...rest }) => {
        if (type === 'form') return null
        return (
          <Select
            {...rest}
            placeholder="请选择任务类型"
            options={[{ label: '全部', value: '' }, ...Object.entries(asyncTaskType)?.map(([value, label]) => ({ label, value }))]}
          />
        )
      },
      render: (_, record) => asyncTaskType[record?.taskType] || '-',
    },
    {
      title: '任务名称',
      dataIndex: 'name',
      ellipsis: true,
      search: false
    },
    {
      title: '任务状态',
      dataIndex: 'status',
      tooltip: '任务失败时，移入可查看具体失败原因',
      ellipsis: true,
      search: false,
      render: (_, record) => {
        const asyncTaskStatusMap = Object.keys(asyncTaskStatus)?.reduce((pre, item) => {
          // eslint-disable-next-line no-param-reassign
          pre[item] = item
          return pre
        }, {})
        if (record.status === asyncTaskStatusMap.FAIL) {
          return (
            <Tooltip placement="top" title={record?.errorMessage ? JSON.parse(record?.errorMessage)?.join('，') : '-'} overlayStyle={{ maxWidth: '800px' }}>
              <span style={{ color: 'var(--app-color-danger)' }}>{ asyncTaskStatus[record.status] }</span>
            </Tooltip>
          )
        }
        const style = {
          color: record.status === asyncTaskStatusMap.FINISHED ? 'var(--ant-primary-color)' : 'rgb(23, 119, 255)'
        }
        return <span style={style}>{ asyncTaskStatus[record.status] || '-' }</span>
      },
    },
    {
      title: '创建日期',
      dataIndex: 'createDate',
      ellipsis: true,
      search: false,
      render: (_, record) => (record?.createDate ? moment(record?.createDate).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
  ]

  const request = useCallback(async (params = {}) => {
    const r = await getAsyncTask(params)
    return {
      data: r || [],
      success: true,
    }
  }, [])

  return (
    <ProTable
      actionRef={actionRef}
      columns={columns}
      scroll={{ x: 'max-content', y: 500 }}
      request={request}
      rowKey="id"
      form={{ form }}
      toolbar={{
        settings: null,
      }}
      search={{
        labelWidth: 'auto',
        span: 6,
        collapseRender: false,
        collapsed: false,
      }}
      pagination={false}
    />
  )
}

export default AsyncTask
